import { formatInstant, formatUtcInstant } from '../lib/time'

/** An instant in the viewer's zone, labelled, with the exact UTC instant on hover.
 *  Renders `fallback` when there is no value. */
export default function Instant({ iso, style = 'full', fallback = null }) {
  if (!iso) return fallback
  return (
    <time dateTime={iso} title={formatUtcInstant(iso)}>
      {formatInstant(iso, { style })}
    </time>
  )
}
